import ReactMarkdown from 'react-markdown'

type Props = {
  markdown: string
}

export function LegalMarkdown({ markdown }: Props) {
  return (
    <div className="legal-markdown">
      <ReactMarkdown
        components={{
          h1: ({ children }) => <h1 className="h2 mb-4">{children}</h1>,
          h2: ({ children }) => <h2 className="h4 mt-5 mb-3">{children}</h2>,
          h3: ({ children }) => <h3 className="h5 mt-4 mb-2">{children}</h3>,
          h4: ({ children }) => <h4 className="h6 mt-3 mb-2 text-body-secondary">{children}</h4>,
          p: ({ children }) => <p className="mb-3 lh-lg">{children}</p>,
          ul: ({ children }) => <ul className="mb-3 ps-4">{children}</ul>,
          ol: ({ children }) => <ol className="mb-3 ps-4">{children}</ol>,
          li: ({ children }) => <li className="mb-1">{children}</li>,
          a: ({ href, children }) => <a href={href}>{children}</a>,
          strong: ({ children }) => <strong className="fw-semibold">{children}</strong>,
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  )
}
